export const taiwanVehicleRegistrationIssueDateFormatStrategy = (
  value: string,
) => {
  // This is the YYY-MM-DD format
  // YYY should be between 000 and 999
  // MM should only be between 01 and 12
  // DD should only be between 01 and 31
  // Test the format

  const regex = /^\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
  return regex.test(value);
};
